import styled, { keyframes, css } from 'styled-components';

type Props = {
  iterationCount?: number;
  duration?: string;
  easing?: string;
  fillMode?: string;
  delay?: string;
  className?: string;
};

const scaleDown3dKeyframe = keyframes`
  0% {
    opacity: 0;
    transform: scale3d(1, 1, 1);
  }
  4% {
    opacity: 1;
  }
  100% {
    transform: scale3d(1.15, 1.15, 1.15);
  }
`;

const ScaleDown3d = styled.div<Props>`
  animation-name: ${scaleDown3dKeyframe};
  animation-duration: ${({ duration = '12s' }) => duration};
  animation-timing-function: ${({ easing = 'ease-in-out' }) => easing};
  animation-delay: ${({ delay = '0s' }) => delay};
  animation-fill-mode: ${({ fillMode = 'forwards' }) => fillMode};
  animation-iteration-count: ${({ iterationCount = 1 }) => iterationCount};
  height: 100%;
  width: 100%;
`;

export default ScaleDown3d;
